import 'react-app-polyfill/ie11';
import 'babel-polyfill';
import 'react-app-polyfill/stable';
import 'core-js/stable';
import 'raf/polyfill';
import React from "react";
import ReactDOM from "react-dom";
import {createBrowserHistory} from "history";
import {Redirect, Route, Router, Switch} from "react-router-dom";

import "perfect-scrollbar/css/perfect-scrollbar.css";
import "./assets/scss/styles.scss";
import "@fontsource/hind-vadodara";
import moment from 'moment'
import 'moment/locale/fr';

import AdminLayout from "./layouts/Admin.tsx";

/* istanbul ignore file */
const hist = createBrowserHistory();

moment.locale('fr');

ReactDOM.render(
    <Router history={hist}>
        <Switch>
            <Route path="/admin" render={props => <AdminLayout {...props} />}/>
            <Redirect to="/admin/login"/>
        </Switch>
    </Router>,
    document.getElementById("root")
);
